"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["title", "innerHTML"];
const _hoisted_2 = {
    key: 0,
    class: "log-plain-text"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
    key: 3,
    class: "log-card background-color-global-event"
};
const _hoisted_7 = { key: 4 };
const _hoisted_8 = {
    key: 5,
    class: "log-card background-color-colony"
};
const _hoisted_9 = {
    key: 6,
    class: "log-excavation-token"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
    width: "20",
    height: "14",
    viewBox: "0 0 28 37"
};
const _hoisted_12 = ["fill"];
const _hoisted_13 = { key: 8 };
const _hoisted_14 = { key: 9 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return (_ctx.message !== undefined && _ctx.message.data !== undefined && _ctx.message.message !== undefined)
        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("li", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = (0, vue_1.withModifiers)(($event) => (_ctx.$emit('click')), ["prevent"])),
            class: (0, vue_1.normalizeClass)({ 'log-steal': _ctx.isStealMessage })
        }, [
            (_ctx.message.type !== _ctx.LogMessageType.NEW_GENERATION)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                    key: 0,
                    title: _ctx.when,
                    innerHTML: _ctx.icon
                }, null, 8, _hoisted_1))
                : (0, vue_1.createCommentVNode)("", true),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.entries, (data, idx) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: idx }, [
                    (typeof (data) === 'string')
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_2, (0, vue_1.toDisplayString)(data), 1))
                        : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_3, [
                            (data.type === undefined || data.value === undefined)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_4))
                                : (data.type === _ctx.LogMessageDataType.PLAYER)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                                        key: 1,
                                        class: (0, vue_1.normalizeClass)(["log-player", 'player_bg_color_' + data.value])
                                    }, (0, vue_1.toDisplayString)(_ctx.getPlayerName(data.value)), 3))
                                    : (data.type === _ctx.LogMessageDataType.CARD)
                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                                            key: 2,
                                            innerHTML: _ctx.cardToHtml(data)
                                        }, null, 8, _hoisted_5))
                                        : (data.type === _ctx.LogMessageDataType.GLOBAL_EVENT)
                                            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_6, [
                                                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(data.value), 1)
                                            ])), [
                                                [_directive_i18n]
                                            ])
                                            : (data.type === _ctx.LogMessageDataType.TILE_TYPE)
                                                ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_7, [
                                                    (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.tileTypeToString[data.value]), 1)
                                                ])), [
                                                    [_directive_i18n]
                                                ])
                                                : (data.type === _ctx.LogMessageDataType.COLONY)
                                                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_8, [
                                                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(data.value), 1)
                                                    ])), [
                                                        [_directive_i18n]
                                                    ])
                                                    : (data.type === _ctx.LogMessageDataType.UNDERGROUND_TOKEN)
                                                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_9, [
                                                            (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.undergroundResourceTokenDescription[data.value]), 1)
                                                        ])), [
                                                            [_directive_i18n]
                                                        ])
                                                        : (data.type === _ctx.LogMessageDataType.SPACE)
                                                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                                                                key: 7,
                                                                class: "log-space-id",
                                                                onClick: (0, vue_1.withModifiers)(($event) => (_ctx.$emit('spaceClicked', data.value)), ["prevent"])
                                                            }, [
                                                                ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("svg", _hoisted_11, [
                                                                    (0, vue_1.createElementVNode)("circle", {
                                                                        cx: "14",
                                                                        cy: "19",
                                                                        r: "16",
                                                                        stroke: "black",
                                                                        "stroke-width": "1",
                                                                        transform: "translate(0, 2)",
                                                                        fill: _ctx.isMoonSpace(data.value) ? 'gray' : '#b7410e'
                                                                    }, null, 8, _hoisted_12)
                                                                ])),
                                                                (0, vue_1.createTextVNode)(" " + (0, vue_1.toDisplayString)(_ctx.getSpaceName(data.value)), 1)
                                                            ], 8, _hoisted_10))
                                                            : (data.type === _ctx.LogMessageDataType.RAW_STRING)
                                                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_13, (0, vue_1.toDisplayString)(data.value), 1))
                                                                : (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_14, [
                                                                    (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(data.value), 1)
                                                                ])), [
                                                                    [_directive_i18n]
                                                                ])
                        ]))
                ], 64));
            }), 128))
        ], 2))
        : (0, vue_1.createCommentVNode)("", true);
}
